import React, { Component } from 'react';
import Header from './Header';
import Tile from './Tile';
import TileCoordinator from './TileCoordinator';

import UIfx from 'uifx';
import clickAudio from './sounds/click.mp3'

const pubSub = require('./util/pubsub');

const clickSound = new UIfx(
    clickAudio,
    {
      volume: 0.4, // number between 0.0 ~ 1.0
      throttleMs: 100
    }
  );
const BOARD_WIDTH = 600;
const BOARD_HEIGHT =  600;
const BOARD_SPACING_RATIO = 0.2;
const BOARD_TILE_RATIO = 0.01;

const EVENT_UNSUB_ALL = 'event-unsub-all';

class Spectate extends Component{

    constructor(props){
        super(props);
        const tileTextSize = BOARD_TILE_RATIO * Math.min(BOARD_WIDTH, BOARD_HEIGHT);
        const specs = {
            board: {
                width: BOARD_WIDTH,
                height: BOARD_HEIGHT,
                spacing: {
                    horizontal: BOARD_WIDTH * BOARD_SPACING_RATIO,
                    vertical: BOARD_HEIGHT * BOARD_SPACING_RATIO
                }
            },
            tile: {
                width: tileTextSize * Tile.CSS_WIDTH_EM,
                height: tileTextSize * Tile.CSS_HEIGHT_EM
            }
        };
        const boardStyle = {
            width: specs.board.width,
            height: specs.board.height
        };
        
        this.coord = new TileCoordinator(specs);

        this.state = {
            scoreDetails:false,
            boardStyle: boardStyle,
            tileTextSize: tileTextSize,
            placeholders: [],
            hands: {},
            starter : 0,
            scores: {
                current:{
                    a: {
                        rounds: [],
                        total: 0
                    },
                    b: {
                        rounds: [],
                        total: 0
                    }
                },
                previous: {
                    a: 0,
                    b: 0
                },
                series: {
                    a: 0,
                    b: 0
                }
            },
        }

        
        this.roomId = props.match.params.roomId;

        const dis = this;

        pubSub.sub(EVENT_UNSUB_ALL, pubSub.sub(pubSub.EVENT_REQUEST_START, () => {
            dis.setState({ isBusy: true });
        }));

        pubSub.sub(EVENT_UNSUB_ALL, pubSub.sub(pubSub.EVENT_REQUEST_END, () => {
            dis.setState({ isBusy: false });
        }));
    }

    componentDidMount() {
        pubSub.sub(EVENT_UNSUB_ALL, this.props.service.fs.doc(`rooms/${this.roomId}`).onSnapshot(doc => {
            
            if (doc.exists) {

                let room = doc.data();
                let board = room.board;
                let left;
                let right;
                let starter = room.starter;

                let scoresObj = room.scores ? room.scores : undefined;

                // Update layout of all played tiles
                let placeholders = [];
                
                if (board && board.tiles) {

                    let result = this.coord.placeTiles(board.tiles);
                    placeholders = result.placeholders;
                    left = result.left;
                    right = result.right;
                }

                // Default new state with new layout of tiles
                let newState = {
                    roomName: room.name,
                    placeholders: placeholders,
                    hands: {},
                    turnOf: room.turnOf,
                    left: left,
                    right: right,
                    starter: starter,
                    seat0: room.seat0,
                    seat1: room.seat1,
                    seat2: room.seat2,
                    seat3: room.seat3,
                    scores: scoresObj
                };

                if (this.state.turnOf !== newState.turnOf) {
                    clickSound.play();
                }

                // Check every seat to update the amount of tiles and 
                //  update the new state object before calling setState()
                for (let i = 0; i < 4; i++) {

                    const key = `seat${i}`;

                    newState.hands[key] = 0;

                    if (room[key] && room[key].handCount) {
                        newState.hands[key] = room[key].handCount;
                    }
                }

                // Define rotation based on starter vs this seat. Also,
                //  check the new state object has the state hasn't 
                //  been updated
                if (newState.starter !== undefined) {
                    
                    
                    let indexDelta = newState.starter - this.props.seat;
                    var degrees = indexDelta * -90;

                    // Keep degrees positive to match css class [0, 90, 180, 270]
                    if (degrees < 0) {
                        degrees += 360
                    }

                    this.boardRotation = `rotation${degrees}`;
                }

                this.setState(newState);
            }else{
                console.log("Room does not exist!")
            }
        }));

    }

    toggleScoreDetails = ()=>{
        this.setState({
            scoreDetails: !this.state.scoreDetails
        });
    }

    

    render(){
        const tilePositionOffset = {
            x: this.coord.specs.tile.width / 2,
            y: (this.coord.specs.tile.height / 2) //50px top offset to avoid blocking own tiles
        };
        const scoreDetail_style = {
            maxHeight: (this.state.scores.current.a.rounds.length * 25) + "px"
        }
        let teammateName = this.state[`seat2`]
            ? this.state[`seat2`].displayName : `Seat 2`;
        let leftName = this.state[`seat3`]
            ? this.state[`seat3`].displayName :  `Seat 3`;
        let rightName = this.state[`seat1`]
            ? this.state[`seat1`].displayName : 'Seat 1';
        let hostName = this.state[`seat0`]
        ? this.state[`seat0`].displayName : `Seat 0`;
        const otherHandStyle = {
            width: `${Tile.CSS_WIDTH_EM}em`,
            //'height': `${Tile.CSS_HEIGHT_EM}em`,
            height: `${Tile.CSS_HEIGHT_EM * 0.2}em`,
            fontSize: this.state.tileTextSize,
        };
        const score_a = this.state.scores ? this.state.scores.current.a.total : 0;
        const series_a = this.state.scores ? this.state.scores.series.a : 0;
        const score_b = this.state.scores ? this.state.scores.current.b.total : 0;
        const series_b = this.state.scores ? this.state.scores.series.b : 0;
        let name_a = "Team 1";
        let name_b = "Team 2";
        try {
            name_a = `${this.state.seat0.displayName} & ${this.state.seat2.displayName}`;
            name_b = this.state.seat1.displayName + " & " + this.state.seat3.displayName;
        } catch(empty) {}

        return(
            <div>
                <Header title="D6"></Header>
                <div className="main-content"> 
                
                    Spectate - {this.roomId} 
                    <div>
                    <div className="scoreBoxContainer">
                            <div className="scoreBox">
                                <div className="series_score">({series_a} - {series_b})</div>
                                <div className="round_score_container" style={(this.state.scoreDetails) ? scoreDetail_style : null}   >
                                    <div className="team_rounds">
                                        {
                                            this.state.scores.current.a.rounds.map((round, index) => {
                                                let r = this.state.scores.current.a.rounds;
                                                let prev = (index) ? r.slice(0, index ).reduce((a,b)=>{return a+b}) : 0;
                                                return <div> {prev} - {round}</div>;
                                            })
                                        }
                                    </div>
                                    <div className="team_rounds">
                                        {
                                            
                                            this.state.scores.current.b.rounds.map((round, index) => {
                                                let r = this.state.scores.current.b.rounds;
                                                let prev = (index) ? r.slice(0, index ).reduce((a,b)=>{return a+b}) : 0;
                                            return <div key={`score-${index}`}>{prev} - {round}</div>;
                                            })
                                        }
                                    </div>
                                </div>
                                <div className="team_scores">
                                    <div className="team">
                                        <div className="team_name">{name_a}</div>
                                        <div className="score"> {score_a}</div>
                                    </div>
                                    <div className="team">
                                        <div className="team_name">{name_b}</div>
                                        <div className="score">{score_b}</div>
                                    </div>
                                </div>

                                <div className="score_details_btn_container" onClick={this.toggleScoreDetails}>
                                    <div style={(this.state.scoreDetails) ? { transform: 'rotate(180deg)', transformOrigin: '50% 50%' } : {}}> &#8964; </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="gameArea">
                    <div className="teammate">
                        <div className={this.state.turnOf === 2 ? "active-player" : null}>{teammateName}</div>

                        {
                            Array.apply(null, Array(this.state.hands[`seat2`])).map((value, index) => {
                                return <div className="otherHand otherHand_teamate" key={index} style={otherHandStyle}></div>
                            })
                        }
                    </div>
                    <div className="midSection">
                            <div className="other-team">
                                <div className={this.state.turnOf === 3 ? "active-player" : null}>{leftName}</div>
                                {
                                    Array.apply(null, Array(this.state.hands[`seat3`])).map((value, index) => {
                                        return <div className="otherHand" key={index} style={otherHandStyle}></div>
                                    })
                                }
                            </div>
                        <div className="gameBoard" >
                        <div className={`gameTiles`} style={this.state.boardStyle}>
                            {
                                this.state.placeholders.map((value, index) => {

                                    let isLeft = this.state.left
                                        && this.state.left.holder.tile === value.tile;
                                    let isRight = this.state.right
                                        && this.state.right.holder.tile === value.tile;

                                    // Define clicker for both ends
                                    

                                    return <Tile key={index} index={index}
                                        a={value.tile.a} b={value.tile.b}
                                        x={value.x - tilePositionOffset.x} y={value.y - tilePositionOffset.y}
                                        d={value.d}
                                        tileTextSize={this.state.tileTextSize}
                                    />
                                })
                            }
                        </div>
                    </div>
                        <div className="other-team">
                            <div className={this.state.turnOf === 1 ? "active-player" : null}>{rightName}</div>
                                {
                                    Array.apply(null, Array(this.state.hands[`seat1`])).map((value, index) => {
                                        return <div className="otherHand" key={index} style={otherHandStyle}></div>
                                    })
                                }
                        </div>
                    </div>

                    <div className="teammate">
                        <div className={this.state.turnOf === 0 ? "active-player" : null}>{hostName}</div>

                        {
                            Array.apply(null, Array(this.state.hands[`seat0`])).map((value, index) => {
                                return <div className="otherHand otherHand_teamate" key={index} style={otherHandStyle}></div>
                            })
                        }
                    </div>

                </div>
                            
            </div>
        )
    }

}

export default Spectate


// WEBPACK FOOTER //
// ./src/Spectate.jsx